//TODO : Refactor after ai
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

export interface AttributeProps extends HTMLAttributes<HTMLSpanElement> {
  label?: ReactNode;
  value?: ReactNode;
  children?: ReactNode;
  wrap?: boolean;
  align?: "left" | "right" | "center";
  width?: number | string;
  style?: CSSProperties;
}

/** One label-above-value pair. An empty value renders an em dash, never blank. */
export function Attribute({
  label,
  value,
  children,
  wrap = false,
  align = "left",
  width,
  className = "",
  style,
  ...rest
}: AttributeProps) {
  return (
    <span
      className={`bui-attr ${className}`}
      data-wrap={wrap || undefined}
      style={{ width, textAlign: align, ...style }}
      {...rest}
    >
      {label && <span className="bui-attr__label">{label}</span>}
      <span className="bui-attr__value">{children ?? value ?? "—"}</span>
    </span>
  );
}
